import Modal from 'react-bootstrap/Modal';
import './quickpaymodal.scss'
import Select from 'react-select';
import { images } from '../../../utils/customFn';
import { useState } from 'react';
import { CloseIcon } from '../../../icon/icons';


const Mainoptions = [
    { value: 'Account type', label: 'Account type' ,img:`${images['notice.png']}` },
    { value: 'Commercial lines', label: 'Commercial lines',img:`${images['notice.png']}` },
    { value: 'Group life', label: 'Group life',img:`${images['notice.png']}` },
    { value: 'Individual life', label: 'Individual life',img:`${images['notice.png']}` }
];
function QuickpayModal({ handleClose, show }) {
    const [selectedOption, setSelectedOption] = useState(null);

  const handleSelectChange = (selected) => {
    setSelectedOption(selected);
  };
    return (
        <>
            <div className='quickpay_modal'>
                <Modal show={show} onHide={handleClose} className='quickpay_modal'>
                    <Modal.Header>
                        <Modal.Title>How do I find my account or policy number?</Modal.Title>
                        <button type='button' className='close_icon' onClick={handleClose}>
                            <CloseIcon/>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='account_type'>I want to pay my Select an  account type:
                            <Select
                                options={Mainoptions}
                                placeholder="Account type "
                                classNamePrefix="react-select"
                                onChange={handleSelectChange}   
                            /> bill
                        </div>
                        {selectedOption ? (
                            <div className="selected-image">
                                <img
                                    src={selectedOption.img}
                                    alt={selectedOption.label}
                                    style={{ marginTop: '20px', width: '100%', height: 'auto' }}
                                />
                            </div>
                        ):""}
                    </Modal.Body>
                    <Modal.Footer>
                        <button type='button' className='close' onClick={handleClose}>
                            Close
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    );
}

export default QuickpayModal;